import { useGetDispatchPlaceUsers } from '@/features/dispatch-places/dispatch-places.queries';

export const useUsersSection = (dp_id: string) => {
  const { data, isLoading, isError } = useGetDispatchPlaceUsers(dp_id);

  return {
    users: data ?? [],
    isLoading,
    isError,
  };
};
